import React, { useState, useEffect } from 'react';
import { Modal, message, Input, Checkbox, Select, Form, Row, Col } from 'antd';
import { FormComponentProps } from 'antd/lib/form';

const CheckboxGroup = Checkbox.Group;
const Option = Select.Option;

interface Props extends FormComponentProps {
  visible: boolean;
  title: string;
  allList?: any;
  roleList: any;
  changeVisible: (value) => void;
  createRole: (value) => any;
  sysRole: (value) => any;
  createUser: (value) => any;
  getUserInfo: (value) => any;
}

const Modale2 = (props: Props) => {

  const [roleValue, setRoleValue] = useState([])

  const handleCancel = () => {
    props.changeVisible(false)
  }

  const handleOk = (e: any) => {
    props.form.validateFields(['roleName'], (err, values) => {
      if (!err) {
        const data = {
          roleName: values.roleName,
          perms: roleValue
        }
        props.createRole(data)
          .then(
            res => {
              if (!res.error) {
                props.sysRole({
                  page: 1,
                  size: 10
                })
                message.success('创建成功')
                handleCancel()
              }
              setRoleValue([])
            }
          )
      }
    })
  }

  const handleOk2 = (e: any) => {
    props.form.validateFields(['userName', 'email', 'roleId'], (err, values) => {
      if (!err) {
        props.createUser(values)
          .then(
            res => {
              if (!res.error) {
                props.getUserInfo({
                  page: 1,
                  size: 10
                })
                message.success('创建成功')
                handleCancel()
              }
            }
          )
      }
    })
  }

  let plainOptions = props.allList.map((item: any, index: number) => ({
    label: item.name,
    value: item.value
  }))

  let roleList = props.roleList.map((item: any, index: number) => {
    return (
      <Option key={item.roleValue} value={item.id}>{item.roleName}</Option>
    )
  })

  const onChange = (checkedList) => {
    setRoleValue(checkedList)
  }

  const validateToEmail = (rule, value, callback) => {
    const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
    if (value && !reg.test(value)) {
      callback('请输入合法的邮箱地址');
    }
    callback();
  }

  const { getFieldDecorator } = props.form;
  return (
    <Modal
      title={props.title}
      visible={props.visible}
      onOk={props.title === '添加角色' ? handleOk : handleOk2}
      onCancel={handleCancel}
      destroyOnClose={true}
    >
      <Form>
        {
          props.title === '添加角色' ?
            (
              <div>
                {/* <p style={{ fontWeight: 500 }}>角色名称</p> */}
                <Row gutter={24}>
                  <Col span={16}>
                    <Form.Item label="角色名称">
                      {getFieldDecorator('roleName', {
                        rules: [
                          { required: true, message: '请输入角色名称!' },
                          { whitespace: true, message: '请输入角色名称!' }
                        ],
                      })(
                        <Input placeholder="请输入" />
                      )}
                    </Form.Item>
                  </Col>
                </Row>

                <p style={{ fontWeight: 500 }}>权限范围</p>
                <CheckboxGroup options={plainOptions} onChange={onChange} />
              </div>
            )
            :
            (
              <div>
                {/* <p style={{ fontWeight: 500 }}>用户名称</p> */}
                <Row gutter={24}>
                  <Col span={16}>
                    <Form.Item label="用户名称">
                      {getFieldDecorator('userName', {
                        rules: [
                          { required: true, message: '请输入用户名称!' },
                          { whitespace: true, message: '请输入用户名称!' }
                        ],
                      })(
                        <Input placeholder="请输入" />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={16}>
                    {/* <p style={{ fontWeight: 500 }}>用户邮箱</p> */}
                    <Form.Item label="用户邮箱">
                      {getFieldDecorator('email', {
                        rules: [
                          { required: true, message: '请输入邮箱!' },
                          {
                            validator: validateToEmail,
                          }
                        ],
                      })(
                        <Input placeholder="请输入" />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={16}>
                    {/* <p style={{ fontWeight: 500 }}>选择角色</p> */}
                    <Form.Item label="选择角色">
                      {getFieldDecorator('roleId', {
                        rules: [{ required: true, message: '请选择角色!' }],
                      })(
                        <Select style={{ width: '100%' }} placeholder="请选择">
                          {roleList}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            )
        }
      </Form>
    </Modal>
  )
}

export default Form.create()(Modale2) as any